export default __webpack_public_path__ + "static/media/cert-finance-hkgcsmeaa.d108ad9a.jpg";